import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, IsEnum } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { FgStatusEnum, GlobalStatus, OperationTypeEnum, PlantsEnum, ShiftsEnum, SubPlantCodesEnum, WorkStationTypeEnum } from '@gtpl/shared-models/common-models';

export class ProductionInventoryData {
    @ApiProperty()
    @IsOptional()
    productionInventoryId?: number;

    @ApiProperty()
    @IsOptional()
    lotNumber: string;

    @ApiProperty()
    @IsOptional()
    subLotNumber: string;


    @ApiProperty()
    @IsOptional()
    saleOrderId: number;

    @ApiProperty()
    @IsOptional()
    saleOrderItemId?: number;
    @ApiProperty({
        enum: OperationTypeEnum
    })
    @IsEnum(OperationTypeEnum)
    operation: OperationTypeEnum;

    @ApiProperty({
        enum: OperationTypeEnum
    })
    @IsEnum(OperationTypeEnum)
    nextOperation: OperationTypeEnum;

    @ApiProperty()
    @IsNotEmpty({ message: "Quantity should not be empty" })
    physicalQuantity: number;


    @ApiProperty()
    @IsNotEmpty({ message: "Quantity should not be empty" })
    issuedQuantity: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Quantity should not be empty" })
    intransitQuantity?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Quantity should not be empty" })
    wipQuantity?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Quantity should not be empty" })
    wastageQuantity?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Quantity should not be empty" })
    rejectedQuantity?: number;


    @ApiProperty()
    @IsNotEmpty({ message: "Count should not be empty" })
    inputGrade: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Count should not be empty" })
    outputGrade: number;
    @ApiProperty()
    boxes: number;
    @ApiProperty()
    ipBoxes: number;
    @ApiProperty()
    opBoxes: number;


    @ApiProperty({
        enum: ShiftsEnum
    })
    @IsEnum(ShiftsEnum)
    shift: ShiftsEnum;

    @ApiProperty({
        enum: FgStatusEnum
    })
    @IsOptional()
    @IsEnum(FgStatusEnum)
    status?: FgStatusEnum;
    
    @ApiProperty({
        enum: WorkStationTypeEnum
    })
    @IsEnum(WorkStationTypeEnum)
    workStationType: WorkStationTypeEnum;
    
    @ApiProperty()
    @IsNotEmpty({ message: "workstation should not be empty" })
    workstation: number;

    @ApiProperty({
        enum: GlobalStatus
    })
    @IsEnum(GlobalStatus)
    weighmentReq: GlobalStatus;


    @ApiProperty()
    plantId?: number;
    
    @ApiProperty()
    assignedTime?: Date
    // @ApiProperty({
    //     enum: SubPlantCodesEnum
    // })
    // @IsEnum(SubPlantCodesEnum)
    // subPlantId?: SubPlantCodesEnum;

    @ApiProperty()
    subPlantId?: number;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Created User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
    createdUser: string;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Updated User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
    updatedUser: string;
    @ApiProperty()
    mainPlantId?: number;
    @ApiProperty()
    plantType?: string;
    @ApiProperty()
    productionInvId?: number;
}
